import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';

const initialState = {
  error: null,
  data: [],
  addData: {},
};

const slice = createSlice({
  name: 'utilitySuppliers',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getUtilitySuppliersSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateUtilitySupplier(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
  },
});

export default slice.reducer;

export function getUtilitySuppliers(locationId) {
  return async () => {
    try {
      const response = await get(`utilitySuppliers?locationId=${locationId || ''}`);
      if (response.status) {
        dispatch(slice.actions.getUtilitySuppliersSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addUtilitySupplier(body) {
  return async () => {
    try {
      const response = await post('utilitySuppliers', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilitySupplier(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateUtilitySupplier(body) {
  return async () => {
    try {
      const response = await put('utilitySuppliers', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilitySupplier(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deactivateUtilitySupplier(body) {
  return async () => {
    try {
      const response = await deleteMethod('utilitySuppliers', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilitySupplier(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
